import { DELETE_TENANT, DESELECT_ALL_TENANT_IDS, DESELECT_TENANT_ID, DISABLE_TENANT, ENABLE_TENANT, SELECT_ALL_TENANT_IDS, SELECT_ALL_TENANT_PROD, SELECT_ALL_TENANT_TEST, SET_INSTANCE_ID, SELECT_TENANT_ID, SELECT_TENANT_PROD, SELECT_TENANT_TEST, SET_ERROR, SET_LOADING, SET_PROJECT, SET_TENANT_ID, SET_TENANTS, TOGGLE_DELETE_APP_DIALOG, TOGGLE_DELETE_APP_INSTANCE_DIALOG, TOGGLE_DISABLE_APP_DIALOG, TOGGLE_DISABLE_APP_INSTANCE_DIALOG, TOGGLE_SYNC_ALL_TENANTS_DIALOG, TOGGLE_SYNC_TENANT_DIALOG, UPDATE_ALL_TENANTS, UPDATE_PROJECT, UPDATE_TENANT_BY_TENANT_ID, DELETE_TENANT_INSTANCE, DISABLE_TENANT_INSTANCE, ENABLE_TENANT_INSTANCE } from "./TenantsAppEvents";

export const initialTenantsAppState = {
    tenants: [],
    project: {},
    selectedTenantIds: [],
    loading: true,
    selectedTenantId: null,
    selectedInstanceId: null,
    showDeleteAppDialog: false,
    showDisableAppDialog: false,
    showDeleteAppInstanceDialog: false,
    showDisableAppInstanceDialog: false,
    showSycnAllTenantsDialog: false,
    showSyncTenantDialog: false,
    errorMessage: null,
};

export const TenantsAppReducer = (state, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case SET_PROJECT:
            return {
                ...state,
                project: action.payload
            };
        case UPDATE_PROJECT:
            return {
                ...state,
                project: {
                    ...state.project,
                    ...action.payload
                }
            };
        case SELECT_ALL_TENANT_PROD:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    return {
                        ...tenant,
                        syncToProd: action.payload,
                    }
                })
            }
        case SELECT_ALL_TENANT_TEST:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    return {
                        ...tenant,
                        syncToTest: action.payload,
                    }
                })
            }
        case SELECT_TENANT_PROD:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            syncToProd: action.payload.value,
                        };
                    }
                    return tenant;
                })
            };
        case SELECT_TENANT_TEST:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            syncToTest: action.payload.value,
                        };
                    }
                    return tenant;
                })
            };
        case SET_TENANTS:
            return {
                ...state,
                tenants: action.payload
            };
        case DELETE_TENANT:
            return {
                ...state,
                tenants: state.tenants.filter(tenant => tenant._id !== action.payload)
            };
        case DISABLE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                status: "disabled",
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    isActive: false,
                                    instances: tenant.project.tenantProject.instances.map(instance => {
                                        return {
                                            ...instance,
                                            isActive: false
                                        };
                                    })
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case ENABLE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                status: "accepted",
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    isActive: true,
                                    instances: tenant.project.tenantProject.instances.map(instance => {
                                        return {
                                            ...instance,
                                            isActive: true
                                        };
                                    })
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case DELETE_TENANT_INSTANCE:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    instances: tenant.project.tenantProject.instances.filter(instance => instance._id !== action.payload.instanceId)
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case DISABLE_TENANT_INSTANCE:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    instances: tenant.project.tenantProject.instances.map(instance => {
                                        if (instance._id === action.payload.instanceId) {
                                            return {
                                                ...instance,
                                                isActive: false
                                            };
                                        }
                                        return instance;
                                    })
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case ENABLE_TENANT_INSTANCE:
            debugger
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    instances: tenant.project.tenantProject.instances.map(instance => {
                                        if (instance._id === action.payload.instanceId) {
                                            return {
                                                ...instance,
                                                isActive: true
                                            };
                                        }
                                        return instance;
                                    })
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case SET_TENANT_ID:
            return {
                ...state,
                selectedTenantId: action.payload
            };
        case SET_INSTANCE_ID:
            return {
                ...state,
                selectedInstanceId: action.payload
            };
        case SELECT_ALL_TENANT_IDS:
            return {
                ...state,
                selectedTenantIds: state.tenants.map(tenant => tenant._id)
            };
        case DESELECT_ALL_TENANT_IDS:
            return {
                ...state,
                selectedTenantIds: []
            };
        case SELECT_TENANT_ID:
            return {
                ...state,
                selectedTenantIds: [...state.selectedTenantIds, action.payload]
            }
        case DESELECT_TENANT_ID:
            return {
                ...state,
                selectedTenantIds: state.selectedTenantIds.filter(id => id !== action.payload)
            }
        case TOGGLE_DELETE_APP_DIALOG:
            return {
                ...state,
                showDeleteAppDialog: !state.showDeleteAppDialog
            };
        case TOGGLE_DISABLE_APP_DIALOG:
            return {
                ...state,
                showDisableAppDialog: !state.showDisableAppDialog
            };
        case TOGGLE_DELETE_APP_INSTANCE_DIALOG:
            return {
                ...state,
                showDeleteAppInstanceDialog: !state.showDeleteAppInstanceDialog
            };
        case TOGGLE_DISABLE_APP_INSTANCE_DIALOG:
            return {
                ...state,
                showDisableAppInstanceDialog: !state.showDisableAppInstanceDialog
            };
        case TOGGLE_SYNC_ALL_TENANTS_DIALOG:
            return {
                ...state,
                showSycnAllTenantsDialog: !state.showSycnAllTenantsDialog
            };
        case TOGGLE_SYNC_TENANT_DIALOG:
            return {
                ...state,
                showSyncTenantDialog: !state.showSyncTenantDialog
            };
        case UPDATE_ALL_TENANTS:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    return {
                        ...tenant,
                        ...action.payload
                    };
                })
            };
        case UPDATE_TENANT_BY_TENANT_ID:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            ...action.payload.data,
                            project: {
                                ...tenant.project,
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    instances: tenant.project.tenantProject.instances.map(instance => {
                                        if (tenant.syncToProd && instance.instanceType === "Production") {
                                            return {
                                                ...instance,
                                                updatedDate: action.payload.data.lastSyncedAt
                                            };
                                        } else if (tenant.syncToTest && instance.instanceType === "Test") {
                                            return {
                                                ...instance,
                                                updatedDate: action.payload.data.lastSyncedAt
                                            };
                                        }
                                        return instance;
                                    })
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case SET_ERROR:
            return {
                ...state,
                errorMessage: action.payload
            };
        default:
            return state;
    }
}